// extracted by mini-css-extract-plugin
export default {"articleTitle":"companyStructure_articleTitle__hrf1C","pictureContainer":"companyStructure_pictureContainer__uYgt0"};